/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateDocumentRequest,
  CreateMessageRequest,
  Document,
  GetDocumentDownloadUrl200Response,
  ListDocuments200Response,
  ListInboundReferrals200Response,
  ListMessages200Response,
  ListOutboundReferrals200Response,
  ListReferralsByLead200Response,
  Message,
  ReadReceipt,
  ReferralDetail,
  UpdateReadReceiptRequest,
  UpdateReferralRequest,
} from '../models/index';
import {
    CreateDocumentRequestFromJSON,
    CreateDocumentRequestToJSON,
    CreateMessageRequestFromJSON,
    CreateMessageRequestToJSON,
    DocumentFromJSON,
    DocumentToJSON,
    GetDocumentDownloadUrl200ResponseFromJSON,
    GetDocumentDownloadUrl200ResponseToJSON,
    ListDocuments200ResponseFromJSON,
    ListDocuments200ResponseToJSON,
    ListInboundReferrals200ResponseFromJSON,
    ListInboundReferrals200ResponseToJSON,
    ListMessages200ResponseFromJSON,
    ListMessages200ResponseToJSON,
    ListOutboundReferrals200ResponseFromJSON,
    ListOutboundReferrals200ResponseToJSON,
    ListReferralsByLead200ResponseFromJSON,
    ListReferralsByLead200ResponseToJSON,
    MessageFromJSON,
    MessageToJSON,
    ReadReceiptFromJSON,
    ReadReceiptToJSON,
    ReferralDetailFromJSON,
    ReferralDetailToJSON,
    UpdateReadReceiptRequestFromJSON,
    UpdateReadReceiptRequestToJSON,
    UpdateReferralRequestFromJSON,
    UpdateReferralRequestToJSON,
} from '../models/index';

export interface CreateDocumentOperationRequest {
    referralId: string;
    createDocumentRequest: CreateDocumentRequest;
}

export interface CreateMessageOperationRequest {
    referralId: string;
    createMessageRequest: CreateMessageRequest;
}

export interface GetDocumentDownloadUrlRequest {
    referralId: string;
    documentId: string;
}

export interface GetReferralRequest {
    referralId: string;
}

export interface ListDocumentsRequest {
    referralId: string;
    cursor?: string;
    limit?: number;
}

export interface ListInboundReferralsRequest {
    status?: ListInboundReferralsStatusEnum;
    cursor?: string;
    limit?: number;
}

export interface ListMessagesRequest {
    referralId: string;
    cursor?: string;
    limit?: number;
    receiverFacilityId?: string;
    senderFacilityId?: string;
}

export interface ListOutboundReferralsRequest {
    status?: ListOutboundReferralsStatusEnum;
    facilityId?: string;
    recipientFacilityIds?: Array<string>;
    cursor?: string;
    limit?: number;
}

export interface ListReferralsByLeadRequest {
    leadId: string;
}

export interface UpdateReferralOperationRequest {
    referralId: string;
    updateReferralRequest: UpdateReferralRequest;
}

export interface UpsertReadReceiptRequest {
    referralId: string;
    recipientFacilityId: string;
    updateReadReceiptRequest: UpdateReadReceiptRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Attaches a document to a referral. Both the sender and recipient facilities can upload documents. The caller may provide sender_facility_id to specify which facility is uploading; if omitted, defaults to the referral sender facility. When provided, server validates that the facility belongs to the caller\'s organization and is a participant in the referral. 
     * Attach a document to a referral
     */
    async createDocumentRaw(requestParameters: CreateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling createDocument().'
            );
        }

        if (requestParameters['createDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'createDocumentRequest',
                'Required parameter "createDocumentRequest" was null or undefined when calling createDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/referrals/{referral_id}/documents`.replace(`{${"referral_id"}}`, encodeURIComponent(String(requestParameters['referralId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDocumentRequestToJSON(requestParameters['createDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     * Attaches a document to a referral. Both the sender and recipient facilities can upload documents. The caller may provide sender_facility_id to specify which facility is uploading; if omitted, defaults to the referral sender facility. When provided, server validates that the facility belongs to the caller\'s organization and is a participant in the referral. 
     * Attach a document to a referral
     */
    async createDocument(requestParameters: CreateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document> {
        const response = await this.createDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new user message. The sender_user_id is sourced from the JWT sub claim. 
     * Send a message to a referral thread
     */
    async createMessageRaw(requestParameters: CreateMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Message>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling createMessage().'
            );
        }

        if (requestParameters['createMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'createMessageRequest',
                'Required parameter "createMessageRequest" was null or undefined when calling createMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/referrals/{referral_id}/messages`.replace(`{${"referral_id"}}`, encodeURIComponent(String(requestParameters['referralId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMessageRequestToJSON(requestParameters['createMessageRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Creates a new user message. The sender_user_id is sourced from the JWT sub claim. 
     * Send a message to a referral thread
     */
    async createMessage(requestParameters: CreateMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Message> {
        const response = await this.createMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a short-lived (10 min) presigned S3 URL for the ROC-bucket copy of a document. Caller must be the sender or a recipient of the referral (enforced by referralAccess middleware). 
     * Get a presigned download URL for a referral document
     */
    async getDocumentDownloadUrlRaw(requestParameters: GetDocumentDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDocumentDownloadUrl200Response>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling getDocumentDownloadUrl().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getDocumentDownloadUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/referrals/{referral_id}/documents/{document_id}/download-url`.replace(`{${"referral_id"}}`, encodeURIComponent(String(requestParameters['referralId']))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDocumentDownloadUrl200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a short-lived (10 min) presigned S3 URL for the ROC-bucket copy of a document. Caller must be the sender or a recipient of the referral (enforced by referralAccess middleware). 
     * Get a presigned download URL for a referral document
     */
    async getDocumentDownloadUrl(requestParameters: GetDocumentDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDocumentDownloadUrl200Response> {
        const response = await this.getDocumentDownloadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a single referral with its recipients. Returns 404 if the referral does not exist or the caller\'s organization does not have access. 
     * Get a referral by ID
     */
    async getReferralRaw(requestParameters: GetReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferralDetail>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling getReferral().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/referrals/{referral_id}`.replace(`{${"referral_id"}}`, encodeURIComponent(String(requestParameters['referralId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralDetailFromJSON(jsonValue));
    }

    /**
     * Returns a single referral with its recipients. Returns 404 if the referral does not exist or the caller\'s organization does not have access. 
     * Get a referral by ID
     */
    async getReferral(requestParameters: GetReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferralDetail> {
        const response = await this.getReferralRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a paginated list of documents attached to a referral.
     * List documents for a referral
     */
    async listDocumentsRaw(requestParameters: ListDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocuments200Response>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling listDocuments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/referrals/{referral_id}/documents`.replace(`{${"referral_id"}}`, encodeURIComponent(String(requestParameters['referralId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDocuments200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of documents attached to a referral.
     * List documents for a referral
     */
    async listDocuments(requestParameters: ListDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocuments200Response> {
        const response = await this.listDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a paginated list of referrals where the caller\'s organization is a recipient. Each item contains the recipient record with a nested referral object (nullable when the parent referral is missing). Organization is determined from the JWT. 
     * List inbound referrals
     */
    async listInboundReferralsRaw(requestParameters: ListInboundReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInboundReferrals200Response>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/referrals/inbound`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListInboundReferrals200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of referrals where the caller\'s organization is a recipient. Each item contains the recipient record with a nested referral object (nullable when the parent referral is missing). Organization is determined from the JWT. 
     * List inbound referrals
     */
    async listInboundReferrals(requestParameters: ListInboundReferralsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInboundReferrals200Response> {
        const response = await this.listInboundReferralsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a paginated list of messages sorted chronologically (oldest first).
     * List messages for a referral
     */
    async listMessagesRaw(requestParameters: ListMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListMessages200Response>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling listMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['receiverFacilityId'] != null) {
            queryParameters['receiver_facility_id'] = requestParameters['receiverFacilityId'];
        }

        if (requestParameters['senderFacilityId'] != null) {
            queryParameters['sender_facility_id'] = requestParameters['senderFacilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/referrals/{referral_id}/messages`.replace(`{${"referral_id"}}`, encodeURIComponent(String(requestParameters['referralId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListMessages200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of messages sorted chronologically (oldest first).
     * List messages for a referral
     */
    async listMessages(requestParameters: ListMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListMessages200Response> {
        const response = await this.listMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a paginated list of referrals sent by the caller\'s organization. Organization is determined from the JWT. When `facility_id` is provided, results are scoped to referrals sent from that facility. When `recipient_facility_ids` is provided, results are scoped to referrals that have at least one recipient in the given facilities (partner portal use case). When both are present, both filters are applied — only referrals sent from `facility_id` that also have a recipient in one of `recipient_facility_ids` are returned. 
     * List outbound referrals
     */
    async listOutboundReferralsRaw(requestParameters: ListOutboundReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOutboundReferrals200Response>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['recipientFacilityIds'] != null) {
            queryParameters['recipient_facility_ids'] = requestParameters['recipientFacilityIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/referrals/outbound`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListOutboundReferrals200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of referrals sent by the caller\'s organization. Organization is determined from the JWT. When `facility_id` is provided, results are scoped to referrals sent from that facility. When `recipient_facility_ids` is provided, results are scoped to referrals that have at least one recipient in the given facilities (partner portal use case). When both are present, both filters are applied — only referrals sent from `facility_id` that also have a recipient in one of `recipient_facility_ids` are returned. 
     * List outbound referrals
     */
    async listOutboundReferrals(requestParameters: ListOutboundReferralsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOutboundReferrals200Response> {
        const response = await this.listOutboundReferralsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a non-paginated list of referrals associated with the given lead, filtered to only those the caller\'s organization can access (as sender or recipient). Organization is determined from the JWT. 
     * List referrals for a lead
     */
    async listReferralsByLeadRaw(requestParameters: ListReferralsByLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListReferralsByLead200Response>> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling listReferralsByLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/referrals/by-lead/{lead_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters['leadId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListReferralsByLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a non-paginated list of referrals associated with the given lead, filtered to only those the caller\'s organization can access (as sender or recipient). Organization is determined from the JWT. 
     * List referrals for a lead
     */
    async listReferralsByLead(requestParameters: ListReferralsByLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListReferralsByLead200Response> {
        const response = await this.listReferralsByLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a referral\'s discharge date. Only the sender organization can update referrals. Returns 403 if the caller is not the sender organization. 
     * Update a referral
     */
    async updateReferralRaw(requestParameters: UpdateReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling updateReferral().'
            );
        }

        if (requestParameters['updateReferralRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferralRequest',
                'Required parameter "updateReferralRequest" was null or undefined when calling updateReferral().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/referrals/{referral_id}`.replace(`{${"referral_id"}}`, encodeURIComponent(String(requestParameters['referralId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferralRequestToJSON(requestParameters['updateReferralRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates a referral\'s discharge date. Only the sender organization can update referrals. Returns 403 if the caller is not the sender organization. 
     * Update a referral
     */
    async updateReferral(requestParameters: UpdateReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReferralRaw(requestParameters, initOverrides);
    }

    /**
     * Creates or updates the caller\'s read position for a specific recipient thread. user_id and user_facility_id are derived server-side from the JWT and referral; callers do not supply them. 
     * Mark messages as read in a recipient thread
     */
    async upsertReadReceiptRaw(requestParameters: UpsertReadReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReadReceipt>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling upsertReadReceipt().'
            );
        }

        if (requestParameters['recipientFacilityId'] == null) {
            throw new runtime.RequiredError(
                'recipientFacilityId',
                'Required parameter "recipientFacilityId" was null or undefined when calling upsertReadReceipt().'
            );
        }

        if (requestParameters['updateReadReceiptRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReadReceiptRequest',
                'Required parameter "updateReadReceiptRequest" was null or undefined when calling upsertReadReceipt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/referrals/{referral_id}/threads/{recipient_facility_id}/read-receipts`.replace(`{${"referral_id"}}`, encodeURIComponent(String(requestParameters['referralId']))).replace(`{${"recipient_facility_id"}}`, encodeURIComponent(String(requestParameters['recipientFacilityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReadReceiptRequestToJSON(requestParameters['updateReadReceiptRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadReceiptFromJSON(jsonValue));
    }

    /**
     * Creates or updates the caller\'s read position for a specific recipient thread. user_id and user_facility_id are derived server-side from the JWT and referral; callers do not supply them. 
     * Mark messages as read in a recipient thread
     */
    async upsertReadReceipt(requestParameters: UpsertReadReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReadReceipt> {
        const response = await this.upsertReadReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListInboundReferralsStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Declined: 'declined'
} as const;
export type ListInboundReferralsStatusEnum = typeof ListInboundReferralsStatusEnum[keyof typeof ListInboundReferralsStatusEnum];
/**
 * @export
 */
export const ListOutboundReferralsStatusEnum = {
    Draft: 'draft',
    Sent: 'sent',
    Confirmed: 'confirmed',
    Closed: 'closed'
} as const;
export type ListOutboundReferralsStatusEnum = typeof ListOutboundReferralsStatusEnum[keyof typeof ListOutboundReferralsStatusEnum];
